export const GET_DBT_MODELS = "GET-DBT-MODELS";
export const GET_DBT_MODEL_BY_ID = "GET-DBT-MODEL-BY-ID";
export const GET_DBT_MODELS_FILTERS = "GET-DBT-MODELS-FILTERS";
export const GET_SQL_LINEAGE_BY_ID = "GET-SQL-LINEAGE-BY-ID";
